"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
require("./button.less");
var useFocusRef_1 = require("spry-react/utils/hooks/useFocusRef");
function ButtonInternal(props) {
    var _a;
    var buttonHtml = useFocusRef_1.useFocusRef(props.focusRef);
    var clickHandler = props.disabled
        ? undefined
        : props.onClick;
    var backgroundColor = props.color || 'default';
    var foregroundColor = foregroundColorTable[_a = props.color, (_a !== null && _a !== void 0 ? _a : 'default')];
    var buttonClasses = classNames('button', {
        'default-button': backgroundColor === 'default',
        'subdued-button': backgroundColor === 'subdued',
        'primary-button': backgroundColor === 'primary',
        'transparent-button': backgroundColor === 'transparent',
        'transparent-button-reverse': backgroundColor === 'transparent-reverse',
        'complementary-button': backgroundColor === 'complementary',
        'button-foreground-default': foregroundColor === 'default',
        'button-foreground-subdued': foregroundColor === 'subdued',
        'button-foreground-dark': foregroundColor === 'dark',
        'button-foreground-white': foregroundColor === 'white',
        'button-tight': props.padding === 'tight',
        'button-no-transform': props.textTransform === 'none',
        'button-full-width': props.fullWidth,
        'button-bold': props.bold
    });
    var hasStartIcon = !!props.startIcon;
    var hasStartIconClass = hasStartIcon && typeof (props.startIcon) === 'string' && props.startIcon.length > 0;
    var hasEndIcon = !!props.endIcon;
    var hasEndIconClass = hasEndIcon && typeof (props.endIcon) === 'string' && props.endIcon.length > 0;
    return (React.createElement("button", { onClick: clickHandler, className: buttonClasses, disabled: props.disabled, title: props.title, ref: buttonHtml },
        React.createElement(React.Fragment, null,
            hasStartIcon && hasStartIconClass &&
                React.createElement("i", { className: props.startIcon }),
            hasStartIcon && !hasStartIconClass &&
                (props.startIcon),
            props.children,
            hasEndIcon && hasEndIconClass &&
                React.createElement("i", { className: classNames(props.endIcon, 'no-padding-psuedo-elements'), style: { marginLeft: '0.5em' } }),
            hasEndIcon && !hasEndIconClass &&
                (props.endIcon))));
}
function Button(props) {
    return React.createElement(ButtonInternal, __assign({}, props));
}
exports.Button = Button;
function OutlineButton(props) {
    var children = props.children, reverseColor = props.reverseColor, propsRest = __rest(props, ["children", "reverseColor"]);
    return (React.createElement(ButtonInternal, __assign({}, propsRest, { color: reverseColor ? 'transparent-reverse' : 'transparent' }), children));
}
exports.OutlineButton = OutlineButton;
var foregroundColorTable = {
    default: 'default',
    primary: 'white',
    subdued: 'subdued',
    transparent: 'subdued',
    'transparent-reverse': 'white',
    complementary: 'white'
};
function LinkButton(props) {
    var children = props.children, propsRest = __rest(props, ["children"]);
    return (React.createElement(ButtonInternal, __assign({}, propsRest, { color: 'default', padding: 'tight', textTransform: 'none' }), children));
}
exports.LinkButton = LinkButton;
function EditorGridAddButton(props) {
    var children = props.children, propsRest = __rest(props, ["children"]);
    return (React.createElement(ButtonInternal, __assign({}, propsRest, { color: 'default', foregroundColor: 'dark', textTransform: 'none', bold: true, startIcon: 'add-icon', fullWidth: true }), children));
}
exports.EditorGridAddButton = EditorGridAddButton;
function ButtonSubText(props) {
    return (React.createElement("div", { className: 'subtext-container' },
        props.text,
        React.createElement("span", null, props.subText)));
}
exports.ButtonSubText = ButtonSubText;
